module.exports = __webpack_public_path__ + "media/images/search-green-4716cbc50107ef73b0c79c9a75b51f43.svg";